<template>
    <div>
        <table class="table" v-if="inputType === 'table'">
                <tr>
                    <th>Type</th>
                    <th>Tid</th>
                    <th>Gem/slet</th>
                </tr>
                <tr>
                    <td>
                        <input type="input" class="input">
                    </td>
                    <td>    
                        <p class="control">
                            <multiselect
                                v-model="absence" 
                                :options="absenceCodes"
                                placeholder="Vælg"
                                track-by="key"
                                label="title"
                                select-label="Vælg"
                                deselect-label="Fjern">
                            </multiselect>
                        </p>
                    </td>
                    <td>
                        <a @click="createType()" class="button is-small is-primary">
                            <span class="icon">
                            <font-awesome-icon icon="check"></font-awesome-icon>
                            </span>
                            Gem
                        </a>
                    </td>
                </tr>
                <tr v-for="value in values" v-bind:key="value.key">
                    <td>
                        <input type="text" class="input">
                    </td>
                    <td>    
                        <p class="control">
                            <multiselect
                                v-model="value.key" 
                                :options="absenceCodes"
                                placeholder="Vælg"
                                track-by="key"
                                label="title"
                                select-label="Vælg"
                                deselect-label="Fjern">
                            </multiselect>
                        </p>
                    </td>
                     <td>
                        <a @click="updateSettings()" class="button is-small is-primary">
                            <span class="icon">
                            <font-awesome-icon icon="check"></font-awesome-icon>
                            </span>
                            Gem
                        </a>
                        <a @click="enableFields = false" class="button is-small is-danger">
                            <span class="icon">
                                <font-awesome-icon icon="times"></font-awesome-icon>
                            </span>
                            Slet
                        </a>
                    </td>
                </tr>
        </table>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'InputProperties',
  components: {
      Multiselect
  },
  props: {
    inputType: String,
    isDisabled: Boolean,
    values: Array,
  },
  data: function() {
      return {
          absenceCodes: [
              {
                key: 'DAYS',
                title: 'Dage'
              },
                            {
                key: 'MONTHS',
                title: 'Måneder'
              },
          ]
      }
  },
  methods: {
      createType() {
          
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .icon {
        margin-right: 0.375em!important;
    }
</style>
